const MAX_SEARCH_PHRASE_FILTER_LENGTH = 15;

export const truncateSearchPhrase = (searchPhrase: string) => {
  return searchPhrase.length > MAX_SEARCH_PHRASE_FILTER_LENGTH
    ? `${searchPhrase.substring(0, MAX_SEARCH_PHRASE_FILTER_LENGTH)}...`
    : searchPhrase || '';
};
